import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Reporting API shell — endpoints are injected from facilityReportQueries.ts and pmReportQueries.ts.
 * This keeps each file focused while sharing a single reducer, middleware, and cache.
 */
export const reportingApi = createApi({
  reducerPath: 'reportingApi',
  baseQuery: createAuthenticatedBaseQuery(apiBaseUrl, 'Reporting API'),
  tagTypes: ['FacilityReport', 'PMReport'],
  endpoints: () => ({}),
});
